// Imagenes de Categorias
import image4 from '../Images/categories/air-conditioning.png';
import image6 from '../Images/categories/business-administration.png';
import image10 from '../Images/categories/communication.png';
import image12 from '../Images/categories/data-science.png';
import image13 from '../Images/categories/dental.png';
import image17 from '../Images/categories/education.png';
import image18 from '../Images/categories/electricity.png';
import image20 from '../Images/categories/engineering.png';
import image21 from '../Images/categories/financial-management.png';
import image22 from '../Images/categories/fire-science.png';
import image23 from '../Images/categories/heating-technology.png';
import image24 from '../Images/categories/home-health-aide.png';
import image30 from '../Images/categories/massage-therapy.png';
import image32 from '../Images/categories/medical-assistant.png';
import image35 from '../Images/categories/nursing.png';
import image39 from '../Images/categories/phlebotomy.png';
import image40 from '../Images/categories/psychology.png';
import image42 from '../Images/categories/refrigeration.png';
import image44 from '../Images/categories/technology.png';

export const availableCategories = [
	{ name: 'air-conditioning', url: image4 },
	{ name: 'business-administration', url: image6 },
	{ name: 'financial-management', url: image21 },
	{ name: 'communication', url: image10 },
	{ name: 'data-science', url: image12 },
	{ name: 'dental', url: image13 },
	{ name: 'phlebotomy', url: image39 },
	{ name: 'education', url: image17 },
	{ name: 'electricity', url: image18 },
	{ name: 'engineering', url: image20 },
	{ name: 'fire-science', url: image22 },
	{ name: 'heating-technology', url: image23 },
	{ name: 'home-health-aide', url: image24 },
	{ name: 'massage-therapy', url: image30 },
	{ name: 'medical-assistant', url: image32 },
	{ name: 'nursing', url: image35 },
	{ name: 'psychology', url: image40 },
	{ name: 'refrigeration', url: image42 },
	{ name: 'technology', url: image44 },
];
